module.exports = __webpack_public_path__ + "img/guide_anzhuo.2aaa9147.svg";